export default function FinalCTA() {
  return (
    <section className="bg-[#1A365D] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-4">Get Started Today</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-5">
            Juneau&apos;s Fastest Passport Service — No Flight to Seattle Needed
          </h2>
          <p className="text-white/70 text-base leading-relaxed mb-8 max-w-2xl mx-auto">
            Fast Passport Center processes passports for Juneau, Mendenhall Valley, Douglas, and all of Southeast Alaska. Start your application today and get your passport in as little as 2–9 business days — with no Seattle flight required.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
            >
              Start My Passport Application <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="tel:8772530084"
              className="inline-flex items-center gap-2 border border-white/30 hover:border-white/60 text-white font-semibold text-base px-8 py-4 rounded-md transition-all whitespace-nowrap"
            >
              <i className="ri-phone-line"></i> 877-253-0084
            </a>
          </div>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <i className="ri-shield-check-line text-[#F6C344]"></i>
              <span>Registered State Dept. Courier</span>
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <i className="ri-award-line text-[#F6C344]"></i>
              <span>A+ BBB Rating</span>
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm">
              <i className="ri-user-line text-[#F6C344]"></i>
              <span>Dedicated Personal Agent</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}